import {
  FormGridItem,
  type FormGridItemProps,
  TextField,
  type TextFieldProps,
  usePhoneNumberValidator,
} from '@ace-clublabs/shared-component-library';
import { defaultInputProps, getRequiredFieldSx } from '../utils';

export interface PhoneNumberFieldProps {
  value?: string;
  onChange: (value: string) => void;
  required?: boolean;
  fieldProps?: Partial<TextFieldProps<'phone-number'>>;
  validatorProps?: Parameters<typeof usePhoneNumberValidator>[0];
  gridItemProps?: Partial<FormGridItemProps>;
}

export const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({
  value,
  onChange,
  required = false,
  fieldProps,
  validatorProps,
  gridItemProps,
}) => {
  const label = 'Phone number';
  const validator = usePhoneNumberValidator({
    label,
    fieldIsRequiredValidationMessage: 'Phone number is required.',
    required,
    ...validatorProps,
  });

  return (
    <FormGridItem
      size={{ xs: 12, lg: 6 }}
      {...gridItemProps}
      sx={getRequiredFieldSx(required)}
    >
      <TextField
        for='phone-number'
        label={label}
        {...defaultInputProps}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        validator={validator}
        data-testid='phoneNumber'
        slotProps={{
          ...defaultInputProps.slotProps,
          htmlInput: { inputMode: 'numeric', pattern: '[0-9]*' },
        }}
        {...fieldProps}
      />
    </FormGridItem>
  );
};
